import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Lock, Mail } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { user, login } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (user) nav("/", { replace: true });
  }, [user, nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      nav("/", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Errore di accesso");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        background: "var(--pa-bg)",
      }}
      data-testid="login-page"
    >
      <div
        style={{
          background:
            "linear-gradient(180deg, var(--pa-navy) 0%, var(--pa-navy-dark) 100%)",
          color: "white",
          padding: "64px 56px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="pa-logo" style={{ color: "white", fontSize: 18 }}>
          <span style={{ color: "var(--pa-turquoise)" }}>●</span>{" "}
          <span>Portale Acquisizioni</span>{" "}
          <span style={{ opacity: 0.75 }}>Excel</span>
        </div>
        <div>
          <h1
            style={{
              fontSize: "44px",
              lineHeight: 1.1,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              marginBottom: 16,
            }}
          >
            Dai prospetti paghe<br />
            <span style={{ color: "var(--pa-turquoise)" }}>
              all'import Profis,
            </span>{" "}
            in un clic.
          </h1>
          <p
            style={{
              fontSize: 16,
              opacity: 0.78,
              maxWidth: 460,
              lineHeight: 1.55,
            }}
          >
            Carica i PDF dei consulenti del lavoro, ottieni l'Excel pronto per
            l'importazione contabile. Senza più riscritture manuali.
          </p>
        </div>
        <div style={{ fontSize: 12, opacity: 0.55 }}>
          Studio Casali — Ravenna
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 56,
        }}
      >
        <form
          onSubmit={onSubmit}
          className="pa-card"
          style={{ padding: 40, width: "100%", maxWidth: 420 }}
          data-testid="login-form"
        >
          <h2
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "var(--pa-navy)",
              marginBottom: 6,
            }}
          >
            Accedi
          </h2>
          <p
            style={{
              fontSize: 14,
              color: "var(--pa-muted)",
              marginBottom: 28,
            }}
          >
            Inserisci email e password
          </p>

          <label
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: "var(--pa-text)",
              display: "block",
              marginBottom: 6,
            }}
          >
            Email
          </label>
          <div style={{ position: "relative", marginBottom: 16 }}>
            <Mail
              size={16}
              color="#9CA3AF"
              style={{
                position: "absolute",
                left: 12,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <input
              type="email"
              className="pa-input"
              style={{ paddingLeft: 36 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              placeholder="silvia@studio.it"
              data-testid="login-email-input"
            />
          </div>

          <label
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: "var(--pa-text)",
              display: "block",
              marginBottom: 6,
            }}
          >
            Password
          </label>
          <div style={{ position: "relative", marginBottom: 20 }}>
            <Lock
              size={16}
              color="#9CA3AF"
              style={{
                position: "absolute",
                left: 12,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <input
              type="password"
              className="pa-input"
              style={{ paddingLeft: 36 }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              data-testid="login-password-input"
            />
          </div>

          {error && (
            <div
              style={{
                background: "var(--pa-red-bg)",
                color: "var(--pa-red)",
                padding: "10px 12px",
                borderRadius: 8,
                fontSize: 13,
                marginBottom: 16,
              }}
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            className="pa-btn-primary"
            disabled={busy}
            data-testid="login-submit-button"
            style={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: 8,
              fontWeight: 600,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {busy ? <span className="pa-spinner" /> : null}
            {busy ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
